// encryptionUtils.js
// Simple encryption/decryption utilities for storing sensitive data

/**
 * Encrypts a string using browser-specific properties as a salt
 * @param {string} text - The text to encrypt
 * @returns {string} - The encrypted text
 */
export const encryptData = (text) => {
  if (!text) return '';
  
  // Create a browser-specific salt using various properties
  const salt = navigator.userAgent + 
               window.screen.width + 
               window.screen.height + 
               navigator.language +
               window.location.hostname;
  
  // Simple XOR cipher with the salt
  const encrypted = Array.from(text)
    .map((char, i) => {
      const saltChar = salt[i % salt.length];
      // XOR the character code with the salt character code
      const encryptedCharCode = char.charCodeAt(0) ^ saltChar.charCodeAt(0);
      // Convert to hex for safer storage
      return encryptedCharCode.toString(16).padStart(4, '0');
    })
    .join('');
  
  return encrypted;
};

/**
 * Decrypts a string that was encrypted with encryptData
 * @param {string} encryptedText - The encrypted text
 * @returns {string} - The decrypted text
 */
export const decryptData = (encryptedText) => {
  if (!encryptedText) return '';
  
  // Recreate the same salt used for encryption
  const salt = navigator.userAgent + 
               window.screen.width + 
               window.screen.height + 
               navigator.language +
               window.location.hostname;
  
  // Split the hex string into character codes (each is 4 chars)
  const encryptedChars = encryptedText.match(/.{1,4}/g) || [];
  
  // Decrypt each character
  const decrypted = encryptedChars
    .map((hex, i) => {
      const saltChar = salt[i % salt.length];
      // Convert hex back to number and XOR with salt
      const charCode = parseInt(hex, 16) ^ saltChar.charCodeAt(0);
      return String.fromCharCode(charCode);
    })
    .join('');
  
  return decrypted;
};